module.exports = __webpack_public_path__ + "static/media/listing page card type B with tatkal.484a1e75.png";